import {PipeTransform, Pipe} from '@angular/core';
import {isBlank, isString, isArray, StringWrapper} from '../facade/lang';
import {ListWrapper} from '../facade/collection';

import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';
export class SlicePipe implements PipeTransform {
  transform(value: any, start: number, end: number = null): any {
    if (isBlank(value)) return value;
    if (!this.supports(value)) {
      throw new InvalidPipeArgumentException(SlicePipe, value);
    }
    if (isString(value)) {
      return StringWrapper.slice(value, start, end);
    }
    return ListWrapper.slice(value, start, end);
  }

  private supports(obj: any): boolean { return isString(obj) || isArray(obj); }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'slice', pure: false}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
